export const LANG_COOKIE_KEY = 'preferredLanguage'
export const LANG_COOKIE_EXPIRATION_DAYS = 3650